import {dispatchSnackbar} from "src/v2/components/SnackBar/snackbar-bus"

export const parseClipboardCells = text =>
    text.replace(/\r/g, "").split("\n").filter(line => line.length > 0).map(line => line.split("\t"))

export const removeTableHeader = (cells, keys, labels = keys) => {
    const first = cells[0]?.map(value => value.trim().toLocaleLowerCase("pt-BR"))
    const matches = expected => first?.length === expected.length &&
        expected.every((value, index) => first[index] === value.trim().toLocaleLowerCase("pt-BR"))
    if (!matches(keys) && !matches(labels)) {
        throw new Error("Cabeçalho inválido. Copie a tabela com cabeçalho e mantenha a ordem das colunas.")
    }
    const rows = cells.slice(1)
    if (!rows.some(row => row.some(value => value.trim()))) {
        throw new Error("A planilha não contém linhas de dados para colar.")
    }
    return rows
}

export const copyTableToClipboard = async (rows, fields, formatValue = (_, value) => value) => {
    if (!rows?.length) return

    try {
        const lines = [
            fields.join("\t"),
            ...rows.map(row => fields.map(field => String(formatValue(field, row[field]) ?? "")).join("\t")),
        ]
        await navigator.clipboard.writeText(lines.join("\n"))
        dispatchSnackbar("Conteúdo copiado para a área de transferência.", "success")
    } catch (error) {
        dispatchSnackbar(error.message || "Não foi possível copiar os dados.", "error")
    }
}
